import BannerBG from '../components/BannerComponents/BannerBG';
import Banner from '../components/BannerComponents/Banner';
import { Link } from 'react-router-dom';
import Button from "@mui/material/Button";

import React, { Component } from 'react'

import { SearchContext, withSearchConsumer } from "../context/SearchContext";
import HotelList from '../components/SearchResults/HotelList';

class DestinationResult extends Component {
  static contextType = SearchContext;

  render() {
    // console.log(this.context)
    return (
      <>
      <BannerBG bannerBG='roomsBannerBG'>
        <Banner title={`Hotels in ${this.context.destination}`}>
        <Button component={Link} to={"../.."} variant="contained">Back to search</Button>
        </Banner>
      </BannerBG>
      <HotelList/>
      </>
    )
  }
}

export default withSearchConsumer(DestinationResult);
